import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Plus, Minus, ShoppingBag, ArrowRight, ArrowLeft } from 'lucide-react';
import Header from './components/Header6';
import Footer from './components/Footer6';

const Cart6 = () => {
    const navigate = useNavigate();

    const [cartItems, setCartItems] = useState([
        { id: 1, name: 'Chanderi Silk Saree', price: 4999, quantity: 1, size: 'Free Size', color: 'Ivory Gold', image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 2, name: 'Khadi Cotton Kurta', price: 2499, quantity: 1, size: 'M', color: 'Natural White', image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 3, name: 'Block Print Anarkali', price: 3999, quantity: 2, size: 'S', color: 'Indigo', image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=400' },
    ]);

    const updateQuantity = (id, delta) => {
        setCartItems(items => items.map(item => item.id === id ? { ...item, quantity: Math.max(1, item.quantity + delta) } : item));
    };

    const removeItem = (id) => {
        setCartItems(items => items.filter(item => item.id !== id));
    };

    const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const shipping = subtotal > 1499 ? 0 : 149;
    const total = subtotal + shipping;

    const isEmpty = cartItems.length === 0;

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Noto+Serif+Display:wght@400;600;700&family=Nunito:wght@300;400;600&display=swap');
            `}</style>
            <div style={{ fontFamily: "'Nunito', -apple-system, sans-serif" }} className="min-h-screen bg-[#F5F0E8]">
                <Header cartCount={cartItems.length} />

                <main className="pt-24 pb-16 px-4 lg:px-8">
                    <div className="max-w-[1400px] mx-auto">
                        <div className="mb-10">
                            <p className="text-xs font-semibold tracking-[3px] uppercase mb-3" style={{ color: '#8B4513' }}>Shopping</p>
                            <h1 style={{ fontFamily: "'Noto Serif Display', serif" }} className="text-3xl lg:text-5xl font-normal text-[#2C1810] tracking-wide">
                                Your Bag
                            </h1>
                        </div>

                        {isEmpty ? (
                            <div className="text-center py-20">
                                <ShoppingBag size={48} style={{ color: '#D4C5B0', margin: '0 auto 20px' }} />
                                <h2 style={{ fontFamily: "'Noto Serif Display', serif", fontSize: '24px', fontWeight: 400, color: '#2C1810', marginBottom: '12px' }}>Your bag is empty</h2>
                                <p style={{ fontSize: '14px', color: '#7C6B5D', marginBottom: '32px', fontWeight: 300 }}>Explore our handloom collection and find something you love.</p>
                                <button
                                    onClick={() => navigate('/template6/shop')}
                                    style={{ padding: '14px 32px', backgroundColor: '#8B4513', color: '#FFFFFF', border: 'none', borderRadius: '2px', fontSize: '13px', fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', cursor: 'pointer', fontFamily: "'Nunito', sans-serif" }}
                                >
                                    Continue Shopping
                                </button>
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
                                {/* Cart Items */}
                                <div className="lg:col-span-2">
                                    {cartItems.map((item) => (
                                        <div key={item.id} className="flex gap-4 py-6" style={{ borderBottom: '1px solid #E8DFD1' }}>
                                            <div style={{ width: '100px', height: '130px', borderRadius: '3px', overflow: 'hidden', flexShrink: 0, cursor: 'pointer' }}
                                                onClick={() => navigate(`/template6/product/${item.id}`)}>
                                                <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <div className="flex justify-between items-start mb-1">
                                                    <h3 style={{ fontFamily: "'Nunito', sans-serif", fontSize: '15px', fontWeight: 600, color: '#2C1810', margin: 0 }}>{item.name}</h3>
                                                    <button onClick={() => removeItem(item.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', color: '#7C6B5D' }}>
                                                        <X size={18} />
                                                    </button>
                                                </div>
                                                <p style={{ fontSize: '13px', color: '#7C6B5D', margin: '0 0 4px 0', fontWeight: 300 }}>Size: {item.size}</p>
                                                <p style={{ fontSize: '13px', color: '#7C6B5D', margin: '0 0 12px 0', fontWeight: 300 }}>Colour: {item.color}</p>
                                                <div className="flex items-center justify-between">
                                                    <div className="flex items-center" style={{ border: '1px solid #D4C5B0', borderRadius: '2px' }}>
                                                        <button onClick={() => updateQuantity(item.id, -1)} style={{ width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer', color: '#8B4513' }}>
                                                            <Minus size={14} />
                                                        </button>
                                                        <span style={{ width: '32px', textAlign: 'center', fontSize: '13px', fontWeight: 600, color: '#2C1810' }}>{item.quantity}</span>
                                                        <button onClick={() => updateQuantity(item.id, 1)} style={{ width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'none', border: 'none', cursor: 'pointer', color: '#8B4513' }}>
                                                            <Plus size={14} />
                                                        </button>
                                                    </div>
                                                    <span style={{ fontSize: '16px', fontWeight: 600, color: '#8B4513' }}>{`\u20B9${(item.price * item.quantity).toLocaleString('en-IN')}`}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    <button
                                        onClick={() => navigate('/template6/shop')}
                                        className="flex items-center gap-2 mt-6 text-sm"
                                        style={{ color: '#8B4513', background: 'none', border: 'none', cursor: 'pointer', fontFamily: "'Nunito', sans-serif", fontWeight: 600 }}
                                    >
                                        <ArrowLeft size={16} /> Continue Shopping
                                    </button>
                                </div>

                                {/* Order Summary */}
                                <div>
                                    <div style={{ backgroundColor: '#FAF7F2', border: '1px solid #E8DFD1', borderRadius: '4px', padding: '32px' }}>
                                        <h3 style={{ fontFamily: "'Noto Serif Display', serif", fontSize: '20px', fontWeight: 600, color: '#2C1810', marginBottom: '24px' }}>Order Summary</h3>
                                        <div className="space-y-3 mb-6">
                                            <div className="flex justify-between">
                                                <span style={{ fontSize: '14px', color: '#7C6B5D', fontWeight: 300 }}>Subtotal</span>
                                                <span style={{ fontSize: '14px', fontWeight: 600, color: '#2C1810' }}>{`\u20B9${subtotal.toLocaleString('en-IN')}`}</span>
                                            </div>
                                            <div className="flex justify-between">
                                                <span style={{ fontSize: '14px', color: '#7C6B5D', fontWeight: 300 }}>Shipping</span>
                                                <span style={{ fontSize: '14px', fontWeight: 600, color: shipping === 0 ? '#5D7A3A' : '#2C1810' }}>
                                                    {shipping === 0 ? 'Free' : `\u20B9${shipping}`}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="flex justify-between pt-4 mb-6" style={{ borderTop: '1px solid #E8DFD1' }}>
                                            <span style={{ fontSize: '16px', fontWeight: 600, color: '#2C1810' }}>Total</span>
                                            <span style={{ fontSize: '20px', fontWeight: 600, color: '#8B4513' }}>{`\u20B9${total.toLocaleString('en-IN')}`}</span>
                                        </div>
                                        <button
                                            onClick={() => navigate('/template6/checkout')}
                                            className="w-full flex items-center justify-center gap-2"
                                            style={{
                                                padding: '16px', backgroundColor: '#8B4513', color: '#FFFFFF', border: 'none', borderRadius: '2px',
                                                fontSize: '13px', fontWeight: 600, letterSpacing: '1.5px', textTransform: 'uppercase', cursor: 'pointer',
                                                fontFamily: "'Nunito', sans-serif", transition: 'background-color 0.3s',
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#6B3410')}
                                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#8B4513')}
                                        >
                                            Proceed to Checkout <ArrowRight size={16} />
                                        </button>
                                        <p className="text-center mt-4" style={{ fontSize: '12px', color: '#7C6B5D', fontWeight: 300 }}>
                                            Free shipping on orders above {'\u20B9'}1,499
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Cart6;
